// extracted by mini-css-extract-plugin
module.exports = {"cTopicBanner":"C214_TopicBanner_cTopicBanner__OzvNb","banner":"C214_TopicBanner_banner__LQwyV","content-wrapper":"C214_TopicBanner_content-wrapper__1fCvJ"};